module.exports = __webpack_public_path__ + "img/p05.ca990b39.jpg";